import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';
import { ProjectConsultDetailsDrawerComponent } from './project-consult-details-drawer/project-consult-details-drawer.component';
import { ProjectConsultComponent } from './project-consult.component';

@NgModule({
  declarations: [
    ProjectConsultComponent,
    ProjectConsultDetailsDrawerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    B3DesignSystemWebModule,
  ],
  exports: [
    ProjectConsultComponent
  ],
  providers: [
    DatePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProjectConsultModule { }
